import React from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import {
  policyData,
  policyGroups,
  POLICY_UPDATED,
} from "../Datas/policyData";
import "../css/privacy.scss";

const corePolicies = [
  {
    to: "/privacy",
    title: "Privacy Policy",
    summary: "Personal data collection, use, disclosure, retention, and choices.",
  },
  {
    to: "/terms",
    title: "Terms & Conditions",
    summary: "The contract terms that apply to this website and purchases.",
  },
  {
    to: "/cookies",
    title: "Cookie Policy",
    summary: "Cookies, similar technologies, categories, duration, and controls.",
  },
  {
    to: "/shipping",
    title: "Shipping & Delivery Policy",
    summary: "Processing, carriers, estimates, tracking, duties, and delivery issues.",
  },
  {
    to: "/returns",
    title: "Returns & Exchanges Policy",
    summary: "Return windows, conditions, exceptions, exchanges, and refunds.",
  },
];

function PolicyCard({ to, title, summary }) {
  return (
    <li className="policy-center__item">
      <Link to={to} className="policy-center__card">
        <span className="policy-center__card-title">{title}</span>
        <span className="policy-center__card-copy">{summary}</span>
        <span className="policy-center__card-action" aria-hidden="true">
          Read policy →
        </span>
      </Link>
    </li>
  );
}

function PolicyCenter() {
  return (
    <div className="legal-page policy-center">
      <Header />
      <main id="MainContent">
        <div id="cms-content">
          <div>
            <p className="legal-page__eyebrow">Help & legal</p>
            <h1>Store Policy Center</h1>
            <p className="legal-page__updated">
              <strong>Policy library updated: {POLICY_UPDATED}</strong>
            </p>
            <p className="legal-page__intro">
              Find the policies that apply when you browse or shop with
              averlynxstore. Product-page and checkout disclosures may add
              item-specific details, and mandatory rights under applicable law
              always take priority.
            </p>

            <section className="policy-center__group" aria-labelledby="core-policies">
              <h2 id="core-policies">Core store policies</h2>
              <ul className="policy-center__grid">
                {corePolicies.map((policy) => (
                  <PolicyCard key={policy.to} {...policy} />
                ))}
              </ul>
            </section>

            {policyGroups.map((group) => {
              const policies = policyData.filter(
                (policy) => policy.group === group
              );

              return (
                <section className="policy-center__group" key={group}>
                  <h2>{group}</h2>
                  <ul className="policy-center__grid">
                    {policies.map((policy) => (
                      <PolicyCard
                        key={policy.slug}
                        to={`/policies/${policy.slug}`}
                        title={policy.title}
                        summary={policy.summary}
                      />
                    ))}
                  </ul>
                </section>
              );
            })}

            <aside className="legal-page__notice">
              Questions about a policy or an order can be sent to{" "}
              <a href="mailto:cost@averlynxstore.one">
                cost@averlynxstore.one
              </a>
              .
            </aside>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default PolicyCenter;
